import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import "../../../../assets/css/main.css";
import "../../../../assets/css/utility/table.css";
import useHttp from "../../../../hooks/useHttp";
import Earned from "./Earned";
import StatisticsOrder from "./StatisticsOrder";
import Order from "./Order";
import { USER_ORDER_N_EARNING_URL } from "../../../../utils/api-ends";

const OrderRatingStatisticsOrderEarned = () => {
  const { sendRequests } = useHttp();
  const [userRelatedData, setUserRelatedData] = useState({});
  const userData = useSelector((state) => state.basicInfo?.userDetails);

  useEffect(() => {
    const response = (data) => {
      setUserRelatedData(data);
    };

    // Send request to get profile info
    sendRequests(
      {
        url: USER_ORDER_N_EARNING_URL(userData?.id),
        method: "GET",
      },
      response
    );
  }, [userData?.id, sendRequests]);

  return (
    <div>
      {userData?.user_type === "shipper" && userRelatedData?.own_profile === true && (
        <Order userRelatedData={userRelatedData} />
      )}

      <section id="rationg-order-earned">
        <div className="container">
          <div className="rationg-order-earned">
            <StatisticsOrder userRelatedData={userRelatedData} />
            {userRelatedData.own_profile === true &&
              userData.user_type === "carrier" && (
                <Earned userRelatedData={userRelatedData} />
              )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrderRatingStatisticsOrderEarned;
